import  api, { globalErrorHandler } from "../Api"

export const GET_CAFETERIAS = "GET_CAFETERIAS";
export const GET_CAFETERIAS_PRICES = "GET_CAFETERIAS_PRICES";
export const GET_CAFETERIAS_CATEGORIES = "GET_CAFETERIAS_CATEGORIES";
export const CAFETERIA_LOADING = "CAFETERIA_LOADING";
export const CAFETERIA_ERROR = "CAFETERIA_ERROR";

const config = {
    headers: {
        'content-type': 'application/json',
    }
  };

export const GetCafeterias = () => {
  
    return async dispatch => {
      dispatch({
        type: CAFETERIA_LOADING
      });
      await api.get(`/Cafeteria/GetCafeterias`,config).then(res => 
        dispatch({
          type: GET_CAFETERIAS,
          data: res.data
          })
        ).catch((error) => {
            globalErrorHandler(error);
            dispatch({
              type: CAFETERIA_ERROR 
            })
          });; 
    };
  };

  export const GetCafeteriasCategories = () => {
  
    return async dispatch => {
      dispatch({
        type: CAFETERIA_LOADING
      });
      await api.get(`/Cafeteria/GetCafeteriasCategories`,config).then(res => 
        dispatch({
          type: GET_CAFETERIAS_CATEGORIES,
          data: res.data
          })
        ).catch((error) => {
            globalErrorHandler(error);
            dispatch({
              type: CAFETERIA_ERROR 
            })
          });; 
    };
  };

  export const GetCafeteriaPrices = (cafeteria, category, product) => {
   
    return async dispatch => {
      dispatch({
        type: CAFETERIA_LOADING
      });

      let url =  `/Cafeteria/GetCafeteriaPrices?cafeteria=${cafeteria}`;

      if(category.length > 0){
        url += `&category=${category}`;
      }

      if(product.length > 0){
        url += `&product=${product}`;  
      }

      await api.get(url, config).then(res => {
        dispatch({
          type: GET_CAFETERIAS_PRICES,
          data: res.data
        });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: CAFETERIA_ERROR 
        })
      });
    };
  };